import { events, messageBus } from '@schibsted-nmp/advertising-events';
import { debugLog, PageType } from '@schibsted-nmp/advertising-shared';

import { searchFilterCallback } from '../refreshKeywords';
import { $interminglePlacements } from '../../atoms/placements';

type setupEventsProps = {
  pageType: PageType;
};

export function setupEvents({ pageType }: setupEventsProps) {
  const interminglePlacements = $interminglePlacements.get();
  debugLog('placementsWithIntermingle: ', interminglePlacements);

  if (interminglePlacements.length > 0) {
    messageBus.publish(
      events.PODLET.channel,
      events.PODLET.PODLET_READY.topic,
      events.PODLET.PODLET_READY.sendPayload({
        placementsWithIntermingle: interminglePlacements
      })
    );
  }

  // TODO: I don't think this has to be done on load, but might be a good reason!
  if (pageType === 'result') {
    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      searchFilterCallback
    );
  }
}
